// @flow

import {graphql, useStaticQuery} from "gatsby";
import * as React from "react";

type Props = {
    title: string,
    description: string,
    fullTitle?: boolean,
    children?: React$Node,
    location: {
        pathname: string
    },
};

const PageHead = (props: Props): React$Element<React$FragmentType> => {
    /**
     * Query og-image and get the source, width and height.
     * Note that this image should always have an image ratio of 1.91:1 and at least 1200px width.
     * See: https://developers.facebook.com/docs/sharing/best-practices#images
     */
    const { ogImage } = useStaticQuery(graphql`
        query {
            ogImage: file(relativePath: { eq: "og-image.jpg" }) {
                childImageSharp {
                    original {
                        src
                        width
                        height
                    }
                }
            }
        }
    `);

    return (
        <>
            <title>{props.fullTitle ? props.title : `${props.title} - Bru`}</title>
            <meta name="description" content={props.description} />
            <meta name="og:url" content={props.location?.pathname} />
            <meta name="og:type" content="website" />
            <meta name="og:title" content="Bru - Passion for Fabrics" />
            <meta name="og:description" content="Our mission is to supply professionals with high-quality fabrics and set the industry standard for innovation that is valuable for our customers across the globe." />
            <meta name="og:image" content={ogImage.childImageSharp.original.src} />
            <meta name="og:image:width" content={ogImage.childImageSharp.original.width} />
            <meta name="og:image:height" content={ogImage.childImageSharp.original.height} />
            {props.children}
        </>
    )
}

export default PageHead;
